/*
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

const BASE = "/seed";

export const SEED_ROUTES = {
  BASE,
  ROOT: `${BASE}/*`,
  NAME: "Seed",
} as const;

export const SEED_SUMMARY_ROUTE = `${BASE}/summary`;
export const SEED_SUCCESS_ROUTE = `${BASE}/success`;
